module.exports = __webpack_public_path__ + "media/print.e26e4695.svg";